import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const Privacy = () => {
  return (
    <section className="min-h-screen bg-[#0A0E14] pt-24 md:pt-32 pb-16 md:pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8">
        {/* Back Button */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="text-sm">Back to Home</span>
        </Link>

        {/* Header */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Privacy Policy</h1>
        <p className="text-gray-400 mb-12">Last updated: January 2025</p>

        {/* Content */}
        <div className="glass-card rounded-2xl p-8 md:p-12 space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
            <p className="leading-relaxed mb-4">
              At MBhost, we collect information that you provide directly to us when you:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Create an account or sign up for our services</li>
              <li>Use our cloud infrastructure platform</li>
              <li>Contact our support team</li>
              <li>Subscribe to our newsletter or marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Your Information</h2>
            <p className="leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices, updates, and security alerts</li>
              <li>Respond to your comments and questions</li>
              <li>Monitor and analyze trends, usage, and activities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Data Security</h2>
            <p className="leading-relaxed">
              We implement industry-standard security measures to protect your personal information. All data is encrypted in transit using TLS 1.3 and at rest using AES-256 encryption. We maintain ISO 27001 certification and undergo regular security audits.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Data Retention</h2>
            <p className="leading-relaxed">
              We retain your personal information for as long as necessary to provide our services and comply with legal obligations. You can request deletion of your data at any time by contacting our support team.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Third-Party Services</h2>
            <p className="leading-relaxed">
              We may share your information with third-party service providers who assist us in operating our platform, conducting our business, or servicing you. These providers are bound by confidentiality agreements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Your Rights</h2>
            <p className="leading-relaxed mb-4">
              Under GDPR and other privacy laws, you have the right to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Request data portability</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Cookies</h2>
            <p className="leading-relaxed">
              We use cookies and similar tracking technologies to track activity on our platform and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Contact Us</h2>
            <p className="leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us at:
              <br />
              <span className="text-green-400">privacy@mbhost.in</span>
              <br />
              MBhost Cloud Pvt Ltd, A unit of MBT Ventures Ltd.
            </p>
          </section>
        </div>
      </div>
    </section>
  );
};